__turbopack_context__.v({
  "desktop": "video-module-scss-module__syqXNG__desktop",
  "mobile": "video-module-scss-module__syqXNG__mobile",
  "placeholder": "video-module-scss-module__syqXNG__placeholder",
  "video": "video-module-scss-module__syqXNG__video",
});
